import * as React from "react";

export const LineArticle = (props: { content: any }) => {
  return (
    <div className="content">
      <a href="#">{props.content.metadata.name}</a>
    </div>
  );
};
